"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var platform = require("platform");

var ClientInfo = function ClientInfo(version) {
  _classCallCheck(this, ClientInfo);

  this.sdk = 'js';
  this.sdkVer = version;
  this.os = platform.os.family;
  this.osVer = platform.os.version;
  this.pl = platform.name;
  this.plVer = platform.version;
};

exports.ClientInfo = ClientInfo;
exports.default = ClientInfo;